import React from "react";
import styles from "./right-mask.module.css";
import {cn} from "@/lib/utils";

export const RightMask = () => {
    return (
        <div className={cn('absolute z-1 right-0 top-0 bottom-0 w-[143px] pointer-events-none', styles.ExpanderMask)}/>
    )
}
